const ACCOUNT_NUMBER = "reece-account-number";
const USER_PROFILE = "reece-user-profile";
const USER_LOCATION = "reece-user-location";

const read = key => {
  if (!key) {
    return null;
  }

  const cookieRegExp = new RegExp(`${encodeURIComponent(key)}=([^;]+)*`);
  const matches = document.cookie.match(cookieRegExp);
  const hasValue = !!(matches && matches[1]);

  return hasValue ? decodeURIComponent(matches[1]) : null;
};

export const readAccountNumberCookie = () => read(ACCOUNT_NUMBER);
export const readUserProfileCookie = () => JSON.parse(read(USER_PROFILE));
export const readUserLocationCookie = () => JSON.parse(read(USER_LOCATION));
